var GcvComisionesHelper = (function () {
    function hasDataTables() {
        return !!($.fn && ($.fn.DataTable || $.fn.dataTable));
    }

    function isDataTable(tableNode) {
        if ($.fn.DataTable && $.fn.DataTable.isDataTable) {
            return $.fn.DataTable.isDataTable(tableNode);
        }
        if ($.fn.dataTable && $.fn.dataTable.isDataTable) {
            return $.fn.dataTable.isDataTable(tableNode);
        }
        return false;
    }

    function getDataTableApi($table, dtConfig) {
        if ($.fn.DataTable) {
            return dtConfig ? $table.DataTable(dtConfig) : $table.DataTable();
        }
        if ($.fn.dataTable) {
            var legacy = dtConfig ? $table.dataTable(dtConfig) : $table.dataTable();
            return legacy.api ? legacy.api() : legacy;
        }
        return null;
    }

    function formatDecimal(value) {
        if (value === undefined || value === null) {
            return '';
        }
        var raw = String(value).trim();
        if (raw === '' || raw.toLowerCase() === 'null') {
            return '';
        }
        var normalized = raw.replace(',', '.');
        if (!/^-?\d+(\.\d+)?$/.test(normalized)) {
            return raw;
        }
        var parts = normalized.split('.');
        var integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        if (parts.length === 1) {
            return integerPart;
        }
        return integerPart + ',' + parts[1];
    }

    function getColumnTooltip(dataKey, queryType) {
        var tooltips = {
            imp_venta: 'Importe venta',
            imp_sujeto: queryType === 'empleado'
                ? 'Venta sujeta a comisión del empleado'
                : queryType === 'producto'
                    ? 'Venta sujeta a comisión por producto'
                    : 'Venta sujeta a comisión de la tienda',
            imp_coste: 'Importe coste',
            imp_bonificacion: 'Importe bonificación',
            margen: 'Importe margen',
            umbral_viabilidad: 'Umbral de viabilidad',
            comision: 'Denominación comisión',
            denominacion_producto: 'Denominación del producto',
            denominacion_comision_producto: 'Denominación comisión producto',
            pct_umbral_viabilidad_conseguido: '% Umbral de viabilidad conseguido',
            pct_stock_obsoleto: '% Stock obsoleto',
            imp_stk_tot: 'Valoración media stock total',
            imp_stk_obsoleto: 'Valoración media stock obsoleto',
            pto_exc_obs: 'Puntos de excelencia stock obsoleto',
            pto_exc_total: 'Puntos de excelencia',
            id_articulo: 'Identificador del artículo',
            id_linea: 'Identificador de la línea',
            id_familia: 'Identificador de la familia',
            id_subfamilia: 'Identificador de la subfamilia',
            id_marca: 'Identificador de la marca',
            mult_umb_via: 'Multiplicador de umbral de viabilidad',
            mult_umb_via_aplicado: 'Multiplicador de umbral de viabilidad',
            mult_umb_via_max: 'Multiplicador de umbral de viabilidad máximo',
            mult_pto_exc: 'Multiplicador de puntos de excelencia',
            mult_pto_exc_aplicado: 'Multiplicador de puntos de excelencia',
            mult_pto_exc_max: 'Multiplicador de puntos de excelencia máximo',
            venta_tolerada: queryType === 'empleado'
                ? 'Venta tolerada sujeta a comisión del empleado'
                : queryType === 'producto'
                    ? 'Venta tolerada sujeta a comisión por producto'
                    : 'Venta tolerada sujeta a comisión de la tienda',
            ptje_com_base: queryType === 'empleado'
                ? 'Porcentaje comisión base del empleado'
                : 'Porcentaje comisión base de la tienda',
            ptje_com_producto: 'Porcentaje comisión base por producto',
            comision_producto_base: 'Comisión base por producto',
            comision_tienda: 'Comisión a pagar a la tienda',
            ptje_comision: queryType === 'empleado'
                ? 'Porcentaje comisión del empleado'
                : 'Porcentaje comisión de la tienda',
            ptje_comision_producto: 'Porcentaje comisión del empleado por producto',
            comision_empleado: 'Comisión a pagar al empleado',
            comision_empleado_producto: 'Comisión a pagar al empleado por producto',
            dias_duracion_periodo: 'Días de duración del periodo',
            dias_periodo_transcurridos: 'Días del periodo transcurridos',
            pct_umbral_viabilidad_previsto: '% Umbral de viabilidad previsto al final del periodo',
            mult_umb_via_previsto: 'Multiplicador de umbral de viabilidad previsto al final del periodo',
            imp_venta_previsto: queryType === 'empleado'
                ? 'Venta tolerada sujeta a comisión del empleado prevista al final del periodo'
                : 'Venta tolerada sujeta a comisión de la tienda prevista al final del periodo',
            imp_venta_producto_previsto: 'Venta tolerada sujeta a comisión por producto prevista al final del periodo',
            comision_tienda_prevista: 'Comisión a pagar a la tienda prevista al final del periodo',
            comision_tienda_max_prevista: 'Comisión a pagar a la tienda prevista al final del periodo con viabilidad y excelencia máximas',
            comision_empleado_prevista: 'Comisión a pagar al empleado prevista al final del periodo',
            comision_empleado_max_prevista: 'Comisión a pagar al empleado prevista al final del periodo con viabilidad y excelencia máximas',
            comision_empleado_producto_prevista: 'Comisión a pagar al empleado por producto prevista al final del periodo',
            comision_empleado_producto_max_prevista: 'Comisión a pagar al empleado por producto prevista al final del periodo con viabilidad y excelencia máximas'
        };
        return tooltips[dataKey] || null;
    }

    function applyViabilityLegend($target) {
        var legend = 'El color indica rápidamente la situación de las ventas según MULT. VIAB.: 0 rojo por pérdidas, entre 0 y 1 naranja por ventas por debajo del objetivo, 1 ventas en niveles normales y mayor que 1 verde por ventas por encima del objetivo.';
        var legendHtml = ''
            + '<strong>% UMB. VIAB.</strong>'
            + '<p class="uk-margin-small-top uk-margin-small-bottom">El color te permite ver rápidamente si las ventas van por buen o mal camino.</p>'
            + '<strong>Leyenda de colores según MULT. VIAB.</strong>'
            + '<ul class="uk-list uk-list-collapse uk-margin-small-top uk-margin-remove-bottom">'
            + '<li><span class="uk-text-danger"><strong>0</strong> · Rojo:ventas muy por debajo del objetivo o pérdidas</span></li>'
            + '<li><span class="uk-text-warning"><strong>Entre 0 y 1</strong> · Naranja: ventas por debajo del objetivo</span></li>'
            + '<li><strong>1</strong> · Ventas en niveles normales</li>'
            + '<li><span class="uk-text-success"><strong>Mayor que 1</strong> · Verde: ventas por encima del objetivo</span></li>'
            + '</ul>';
        var $legend = $target.find('.gcv-viability-legend');
        if (!$legend.length) {
            $legend = $('<i class="bi bi-question-circle-fill gcv-viability-legend uk-text-secondary uk-margin-small-left" tabindex="0" role="img"></i>');
            $target.append(' ').append($legend);
        }
        $legend.attr('aria-label', legend);
        $legend.attr('uk-tooltip', 'title: ' + legendHtml + '; pos: bottom');
        if (window.UIkit && typeof window.UIkit.tooltip === 'function') {
            window.UIkit.tooltip($legend[0]);
        }
    }

    function applyColumnTooltips(api, queryType) {
        if (!api) {
            return;
        }
        api.columns().every(function () {
            var column = api.settings()[0].aoColumns[this.index()];
            var dataKey = column && column.mData;
            var tooltip = column && (column.tooltip || getColumnTooltip(column.mData, queryType));
            if (!tooltip) {
                return;
            }
            var $header = $(this.header());
            var $span = $header.find('.gcv-column-title');
            if (!$span.length) {
                $span = $('<span class="gcv-column-title"/>').html($header.html());
                $header.empty().append($span);
            }
            $span.attr('title', tooltip);
            $span.attr('aria-label', tooltip);
            if (dataKey === 'pct_umbral_viabilidad_conseguido') {
                applyViabilityLegend($span);
            }
        });
    }

    function readFilterForm($form) {
        var values = {};
        $form.find('input, select, textarea').each(function () {
            var $el = $(this);
            var name = $el.attr('name');
            if (!name) {
                return;
            }
            name = name.replace(/\[\]$/, '');
            if ($el.attr('type') === 'checkbox') {
                values[name] = $el.is(':checked') ? ($el.val() || 1) : 0;
            } else {
                values[name] = $el.val();
            }
        });
        return values;
    }

    function renderTotalesRow(tableNode, totalesFields, totales, label) {
        if (!isDataTable(tableNode)) {
            return;
        }
        var api = getDataTableApi($(tableNode));
        var $table = $(api.table().node());
        $table.find('tbody tr.gcv-totales-row').remove();
        if (!totales || !totalesFields || !totalesFields.length) {
            return;
        }
        label = label || 'TOTALES';
        var $tr = $('<tr class="gcv-totales-row"/>');
        var labelDone = false;
        var labelColumnIndex = null;
        var labelColspan = 0;
        var labelSpanComplete = false;

        api.columns().every(function () {
            var col = api.settings()[0].aoColumns[this.index()];
            var dataKey = typeof col.mData === 'string' ? col.mData : null;
            var isTotal = dataKey && totalesFields.indexOf(dataKey) >= 0;

            if (labelColumnIndex === null) {
                if (!this.visible() || isTotal) {
                    return;
                }
                labelColumnIndex = this.index();
                labelColspan = 1;
                return;
            }

            if (!labelSpanComplete && this.visible()) {
                if (isTotal) {
                    labelSpanComplete = true;
                } else {
                    labelColspan++;
                }
            }
        });

        var labelCellsToSkip = 0;
        api.columns().every(function () {
            var $td = $('<td/>');
            var col = api.settings()[0].aoColumns[this.index()];
            var dataKey = typeof col.mData === 'string' ? col.mData : null;
            if (!this.visible()) {
                $td.css('display', 'none');
                $tr.append($td);
                return;
            }

            if (!labelDone && this.visible() && (!dataKey || totalesFields.indexOf(dataKey) < 0)) {
                $td.addClass('uk-text-left');
                if (this.index() === labelColumnIndex && labelColspan > 1) {
                    $td.attr('colspan', labelColspan);
                }
                $td.append($('<span/>').html(label));
                labelDone = true;
                labelCellsToSkip = labelColspan - 1;
            } else if (labelCellsToSkip > 0 && this.visible() && (!dataKey || totalesFields.indexOf(dataKey) < 0)) {
                labelCellsToSkip--;
                return;
            } else if (!dataKey || totalesFields.indexOf(dataKey) < 0) {
                // Mantener una celda por columna evita desplazar los totales cuando
                // hay columnas no totalizables intercaladas entre ellas.
            } else if (dataKey && totalesFields.indexOf(dataKey) >= 0) {
                $td.css('font-weight', 'bold');
                $td.css('font-size', '1.2em');
                $td.addClass('uk-text-right uk-text-nowrap');
                if (totales[dataKey] !== undefined && totales[dataKey] !== null && totales[dataKey] !== '') {
                    $td.text(formatDecimal(totales[dataKey]) + ' €');
                }
            }
            $tr.append($td);
        });
        $table.find('tbody').append($tr);
    }

    function decimalCol(dataKey, title, showCurrency = false) {
        return {
            data: dataKey,
            title: title,
            className: 'uk-text-right',
            render: function (data) {
                return formatDecimal(data) + (showCurrency ? ' €' : '');
            }
        };
    }

    function parseDecimal(value) {
        if (value === undefined || value === null) {
            return null;
        }
        var normalized = String(value).trim().replace(',', '.');
        if (!/^-?\d+(\.\d+)?$/.test(normalized)) {
            return null;
        }
        var number = Number(normalized);
        return isFinite(number) ? number : null;
    }

    function getViabilityColorClass(multiplier) {
        var value = parseDecimal(multiplier);
        if (value === null) {
            return null;
        }
        if (value === 0) {
            return 'uk-text-danger';
        }
        if (value > 0 && value < 1) {
            return 'uk-text-warning';
        }
        if (value > 1) {
            return 'uk-text-success';
        }
        return null;
    }

    function pctUmbralViabilidadCol(multiplierDataKey, title) {
        return {
            data: 'pct_umbral_viabilidad_conseguido',
            title: title,
            className: 'uk-text-right',
            render: function (data) {
                return formatDecimal(data);
            },
            createdCell: function (cell, data, rowData) {
                var colorClass = getViabilityColorClass(rowData && rowData[multiplierDataKey]);
                $(cell).addClass('uk-text-bold');
                if (colorClass) {
                    $(cell).addClass(colorClass);
                }
            }
        };
    }

    function exportCsv(exportUrl, filterSelector) {
        var values = readFilterForm($(filterSelector));
        var formId = 'gcvComisionesCsvExport';
        $('#' + formId).remove();
        var $form = $('<form id="' + formId + '" method="post" action="' + exportUrl + '" target="_blank"></form>');
        $.each(values, function (key, value) {
            if ($.isArray(value)) {
                $.each(value, function (index, item) {
                    $('<input type="hidden" />')
                        .attr('name', key + '[]')
                        .val(item === null || item === undefined ? '' : item)
                        .appendTo($form);
                });
                return;
            }
            $('<input type="hidden" />')
                .attr('name', key)
                .val(value === null || value === undefined ? '' : value)
                .appendTo($form);
        });
        $('body').append($form);
        $form.submit();
    }

    function blockUI(message) {
        unblockUI();
        var msg = message || '<i uk-spinner="ratio: 0.8"></i> Cargando datos...';
        var html = '' +
            '<div class="blockUI blockOverlay gcv-block-ui" style="display: none"></div>' +
            '<div class="blockUI blockMsg gcv-block-ui">' + msg + '</div>';
        $('body').append(html);
        $('div.blockUI.blockOverlay.gcv-block-ui').fadeIn();
    }

    function unblockUI() {
        $('div.blockUI.gcv-block-ui').fadeOut(function () {
            $(this).remove();
        });
    }

    function buildSearchUrl(values, basePath) {
        var params = {};
        $.each(values, function (key, value) {
            if (value === null || value === undefined || value === '' || value === 0 || value === '0') {
                return;
            }
            params[key] = value;
        });
        params.p = 1;
        var query = $.param(params);
        return basePath + (query ? ('?' + query) : '');
    }

    function init(config) {
        var $table = $(config.tableSelector);
        var $form = $(config.filterSelector);
        var $searchButton = $(config.searchButton);
        var autoLoad = config.autoLoad !== false;
        var searchingByButton = false;
        var initialTotalRecords = parseInt($table.data('total-records'), 10);
        if (!$table.length) {
            return;
        }
        if (!hasDataTables()) {
            console.error('DataTables no está disponible en esta página.');
            return;
        }
        if (!isNaN(initialTotalRecords)) {
            $table.data('gcvTotalRecords', initialTotalRecords);
        }

        var dtConfig = {
            serverSide: true,
            processing: false,
            searching: false,
            paging: false,
            info: false,
            lengthChange: false,
            order: config.order || [[0, 'asc']],
            pageLength: 100,
            language: {
                processing: 'Cargando...',
                emptyTable: 'Seleccione filtros y pulse Buscar',
                zeroRecords: 'No hay datos para los filtros indicados'
            },
            ajax: {
                url: config.dataUrl,
                type: 'POST',
                data: function (d) {
                    var data = $.extend({}, d, readFilterForm($form));
                    if (config.useUrlPagination) {
                        var urlParams = new URLSearchParams(window.location.search);
                        data.p = parseInt(urlParams.get('p'), 10) || 1;
                    }
                    return data;
                },
                dataSrc: function (json) {
                    if (json && json.message === 'session_out') {
                        window.location.href = HOST + '/';
                        return [];
                    }
                    if (json && json.success === false && json.error) {
                        return [];
                    }
                    $table.data('gcvTotales', json && json.totales ? json.totales : null);
                    if (json) {
                        var totalFromJson = null;
                        if (typeof json.recordsFiltered !== 'undefined') {
                            totalFromJson = json.recordsFiltered;
                        } else if (typeof json.iTotalDisplayRecords !== 'undefined') {
                            totalFromJson = json.iTotalDisplayRecords;
                        } else if (typeof json.totalDisplayRecords !== 'undefined') {
                            totalFromJson = json.totalDisplayRecords;
                        } else if (typeof json.totalRecords !== 'undefined') {
                            totalFromJson = json.totalRecords;
                        }
                        if (totalFromJson !== null) {
                            $table.data('gcvTotalRecords', totalFromJson);
                        }
                    }
                    return json && json.data ? json.data : [];
                },
                complete: function () {
                    if (searchingByButton) {
                        searchingByButton = false;
                        unblockUI();
                    }
                }
            },
            columns: config.columns,
            drawCallback: function () {
                var wrapId = $table.attr('id') + '_wrapper';
                $('#' + wrapId + ' .dataTables_length, #' + wrapId + ' .dataTables_paginate').hide();
                $('#' + wrapId + ' .dataTables_info').text('Para ver otros datos, refine la búsqueda mediante los filtros disponibles.');
                applyColumnTooltips(this.api(), config.queryType);
                if (config.totalesFields && config.totalesFields.length) {
                    var totalRecords = $table.data('gcvTotalRecords');
                    var totalsLabel = '<strong style="font-size: 1.2em;">TOTALES</strong>';
                    if (totalRecords !== null && typeof totalRecords !== 'undefined' && totalRecords !== '') {
                        totalsLabel = '<strong style="font-size: 1.2em;">TOTALES</strong> <i class="uk-text-muted uk-text-small">(Datos sobre un total de ' + totalRecords + ' registros)</i>';
                    }
                    renderTotalesRow($table[0], config.totalesFields, $table.data('gcvTotales'), totalsLabel);
                }
            }
        };

        if (!autoLoad) {
            dtConfig.deferLoading = 0;
        }

        var dt = getDataTableApi($table, dtConfig);

        $table.off('error.dt.gcv').on('error.dt.gcv', function () {
            if (searchingByButton) {
                searchingByButton = false;
                unblockUI();
            }
        });

        $searchButton.off('click.gcv').on('click.gcv', function (e) {
            e.preventDefault();
            if (config.useUrlPagination) {
                blockUI(config.searchingMessage || '<i uk-spinner="ratio: 0.8"></i> Cargando comisiones...');
                window.location.href = buildSearchUrl(readFilterForm($form), window.location.pathname);
                return;
            }
            searchingByButton = true;
            blockUI(config.searchingMessage || '<i uk-spinner="ratio: 0.8"></i> Cargando comisiones...');
            dt.ajax.reload(null, false);
        });

        if (config.exportUrl && config.exportButton) {
            $(config.exportButton).on('click', function (e) {
                e.preventDefault();
                exportCsv(config.exportUrl, config.filterSelector);
            });
        }

        return dt;
    }

    return {
        init: init,
        exportCsv: exportCsv,
        formatDecimal: formatDecimal,
        decimalCol: decimalCol,
        pctUmbralViabilidadCol: pctUmbralViabilidadCol
    };
}());
